import { useMutation, useQueryClient } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import toast from 'react-hot-toast'
import { PnsMacMiniUserStatus } from 'interfaces/pns-mac-mini-user'

interface UpdateMacMiniUserStatusParams {
  userId: string
  status: PnsMacMiniUserStatus
}

const updateMacMiniUserStatus = async ({
  userId,
  status,
}: UpdateMacMiniUserStatusParams) => {
  let response = await fetch(
    `${BASE_API_URL}/api/v4/phone_number_service/mac_mini_users/${userId}/status`,
    {
      method: API_METHODS.PUT,
      headers: apiHeaders(store.getState()),
      body: JSON.stringify({ status }),
    }
  )

  response = handleErrors(response)

  return response.json()
}

const useUpdateMacMiniUserStatus = () => {
  const queryClient = useQueryClient()

  return useMutation(updateMacMiniUserStatus, {
    onError: (error: Error) => {
      console.error('Failed to update Mac Mini user status:', error)
      toast.error(`Failed to update Mac Mini user status: ${error.message}`)
    },
    onSuccess: (data, variables) => {
      toast.success('Mac Mini user status updated successfully')

      // Invalidate related queries
      queryClient.invalidateQueries(['mac-mini-user-by-phone'])
      queryClient.invalidateQueries(['mac-mini-users'])
      queryClient.invalidateQueries(['mac-mini-detail'])
    },
  })
}

export default useUpdateMacMiniUserStatus
